import React from 'react';
import { CurrencyDollarIcon } from '@heroicons/react/24/outline';

const Transactions: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Transactions</h1>
      <p className="section-description">
        Manage payment transactions, track payment status, and handle payment confirmations or rejections.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <CurrencyDollarIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Transaction Management</h3>
              <p className="feature-description">
                Handle transactions with the following capabilities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Create new transactions for orders</li>
                <li>Confirm or reject pending payments</li>
                <li>Add admin notes to transactions</li>
                <li>Delete individual transactions</li>
                <li>Bulk delete multiple transactions</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <CurrencyDollarIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Transaction Details</h3>
              <p className="feature-description">
                Comprehensive transaction information management:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Order selection (with event and user details)</li>
                <li>Payment reference ID (unique)</li>
                <li>Status management (Pending, Confirmed, Rejected)</li>
                <li>Admin notes field</li>
                <li>Confirmation timestamp</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <CurrencyDollarIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Transaction List</h3>
              <p className="feature-description">
                View and manage transactions in a table format with the following columns:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Event title (searchable)</li>
                <li>User name (searchable)</li>
                <li>Payment reference (searchable)</li>
                <li>Status (color-coded badges)</li>
                <li>Confirmation date (sortable)</li>
                <li>Creation date (sortable)</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <CurrencyDollarIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Status Management</h3>
              <p className="feature-description">
                Track and manage transaction status:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Pending (yellow badge)</li>
                <li>Confirmed (green badge)</li>
                <li>Rejected (red badge)</li>
                <li>Filter transactions by status</li>
                <li>Requires confirmation for status changes</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Verify payment details before confirming transactions</li>
            <li>Add clear notes when rejecting payments</li>
            <li>Keep accurate records of payment confirmations</li>
            <li>Use status filters to manage transaction groups effectively</li>
            <li>Regularly review pending transactions</li>
            <li>Maintain clear communication with users about payment status</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Transactions; 